// src/store/planTypeSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = 'https//api.monkeybox.ai/api/plantypes';

// Thunks
export const fetchPlanTypes = createAsyncThunk('planTypes/fetchAll', async (_, { rejectWithValue }) => {
  try {
    const res = await axios.get(API_BASE);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const createPlanType = createAsyncThunk('planTypes/create', async (payload, { rejectWithValue }) => {
  try {
    const res = await axios.post(API_BASE, payload);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const updatePlanType = createAsyncThunk('planTypes/update', async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await axios.patch(`${API_BASE}/${id}`, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

const planTypeSlice = createSlice({
  name: 'planType',
  initialState: {
    planTypes: [],
    isLoading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetPlanTypeState: (state) => {
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlanTypes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPlanTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.planTypes = action.payload;
      })
      .addCase(fetchPlanTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createPlanType.fulfilled, (state, action) => {
        state.planTypes.push(action.payload);
        state.success = true;
      })
      .addCase(updatePlanType.fulfilled, (state, action) => {
        const idx = state.planTypes.findIndex(pt => pt.id === action.payload.id);
        if (idx !== -1) state.planTypes[idx] = action.payload;
        state.success = true;
      });
  },
});

export const { resetPlanTypeState } = planTypeSlice.actions;
export default planTypeSlice.reducer;
